<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading"  closable
    :mask-closable="!modalLoading" :okText="getTranslation('r086')" :cancelText="getTranslation('b182')"
    :title="getTranslation('r085')">
    <Row class="field-line" type="flex">
      <Col flex="1">
      <Checkbox v-model="user.curve_current">{{ getTranslation('r087') }}</Checkbox>
      </Col>
      <Col flex="1">
      <Checkbox v-model="user.curve_voltage">{{ getTranslation('r088') }}</Checkbox>
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="1">
      <Checkbox v-model="user.curve_resistance">{{ getTranslation('r089') }}</Checkbox>
      </Col>
      <Col flex="1">
      <Checkbox v-model="user.curve_press">{{ getTranslation('r090') }}</Checkbox>
      </Col>
    </Row>

  </Modal>

</template>
<script>

import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { mapGetters } from 'vuex'
import { postJsError } from '@/util/util.js'
export default {
  name: 'UserEdit', // 组件名称
  components: {    
  },
  props: {
    propVisible: Boolean,
  },
  data() {
    return {
      user: {},
      modalLoading: true,
      mac: null,

    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getSetting()
      }
    }
  },

  created() {
    this.mac = this.$route.query.mac
  },
  methods: {
    getSetting() {
      let url = API_URL["machineSettingInfo"];
      let params = {
        id: this.mac
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.user = res.data.data;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    ok() {
      let _this = this;
      this.modalLoading = true;

      let url = API_URL["machineSettingSet"];

      let params = {
        id: this.mac,
        current: this.user.curve_current ? 1 : 0,
        voltage: this.user.curve_voltage ? 1 : 0,
        resistance: this.user.curve_resistance ? 1 : 0,
        press: this.user.curve_press ? 1 : 0,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            this.$Message.success(this.getTranslation('r091'));
            this.visible = false
            _this.$emit("set-success")
          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {

    }
  },

}
</script>

<style scoped>
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
  font-weight: 550;
}

.field-line {
  margin-bottom: 8px;
}
</style>